"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const isomorphic_html_sanitize_1 = __importDefault(require("isomorphic-html-sanitize"));
const block_1 = __importDefault(require("./block"));
const defaults_1 = __importDefault(require("./defaults"));
const inline_1 = __importDefault(require("./inline"));
const utils_1 = require("./utils");
const log = (0, debug_1.default)('exchange-parser:parser');
class Parser {
    constructor(options) {
        this.parse = (src) => {
            this.inline = new inline_1.default(src.links, this.options);
            this.tokens = src.reverse();
            let out = '';
            while (this.next()) {
                out += this.tok();
            }
            return out;
        };
        this.next = () => {
            this.token = this.tokens.pop();
            return this.token;
        };
        this.peek = () => {
            var _a;
            return (_a = this.tokens[this.tokens.length - 1]) !== null && _a !== void 0 ? _a : 0;
        };
        this.parseText = () => {
            let body = this.token.text;
            while (this.peek().type === 'text') {
                body += this.next().text;
            }
            return (0, utils_1.getText)(this.inline.output(body));
        };
        // parse current token
        this.tok = () => {
            log('Token received', this.token);
            switch (this.token.type) {
                case 'space': {
                    return '';
                }
                case 'hr': {
                    return this.renderer.hr();
                }
                case 'heading': {
                    return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, this.token.text, this.options.minHeaderLevel);
                }
                case 'code': {
                    return this.renderer.code(this.token.text, this.token.lang, this.token.escaped, this.options.escapeNotebooks, this.options.disableNotebooks);
                }
                case 'table': {
                    let header = '';
                    let body = '';
                    // header
                    let cell = '';
                    for (let i = 0; i < this.token.header.length; i += 1) {
                        cell += this.renderer.tablecell(this.inline.output(this.token.header[i]), { header: true, align: this.token.align[i] });
                    }
                    header += this.renderer.tablerow(cell);
                    const isEmptyBody = this.token.cells.length === 1 &&
                        this.token.cells[0].length === 1 &&
                        !this.token.cells[0][0];
                    if (!isEmptyBody) {
                        for (let i = 0; i < this.token.cells.length; i += 1) {
                            const row = this.token.cells[i];
                            let tablecell = '';
                            for (let j = 0; j < row.length; j += 1) {
                                tablecell += this.renderer.tablecell(this.inline.output(row[j]), {
                                    header: false,
                                    align: this.token.align[j]
                                });
                            }
                            body += this.renderer.tablerow(tablecell);
                        }
                    }
                    return this.renderer.table(header, body);
                }
                case 'blockquote_start': {
                    let body = '';
                    while (this.next().type !== 'blockquote_end') {
                        body += this.tok();
                    }
                    return this.renderer.blockquote(body);
                }
                case 'list_start': {
                    let body = '';
                    const { ordered } = this.token;
                    while (this.next().type !== 'list_end') {
                        body += this.tok();
                    }
                    return this.renderer.list(body, ordered);
                }
                case 'list_item_start': {
                    let body = '';
                    while (this.next().type !== 'list_item_end') {
                        body +=
                            this.token.type === 'text'
                                ? this.parseText()
                                : this.tok();
                    }
                    return this.renderer.listitem(body);
                }
                case 'loose_item_start': {
                    let body = '';
                    while (this.next().type !== 'list_item_end') {
                        body += this.tok();
                    }
                    return this.renderer.listitem(body);
                }
                case 'html': {
                    let sanitizedContent;
                    try {
                        sanitizedContent = (0, isomorphic_html_sanitize_1.default)(this.token.text);
                    }
                    catch (error) {
                        sanitizedContent = '';
                    }
                    return this.renderer.html(sanitizedContent);
                }
                case 'paragraph': {
                    return this.renderer.paragraph(this.inline.output(this.token.text));
                }
                case 'text': {
                    return this.renderer.paragraph(this.parseText());
                }
                default: {
                    return '';
                }
            }
        };
        this.tokens = [];
        this.token = null;
        this.options = { ...defaults_1.default, ...options };
        this.renderer = new block_1.default(this.options);
    }
}
exports.default = Parser;
